import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesPhoneAppInstalationComponent} from "./sales-phone-app-instalation.component";
import {SalesCreditCodesSharedComponent} from "./shared/sales-credit-codes/sales-credit-codes-shared.component";
import {PhoneAppConfirmationModalSharedComponent} from "./shared/phone-app-confirmation-modal/phone-app-confirmation-modal-shared.component";
import {PhoneAppFooterButtonSharedComponent} from "./shared/phone-app-footer-button/phone-app-footer-button-shared.component";
import {SalesPhoneKrdyaPlatformComponent} from "./platforms/krdya/sales-phone-krdya-platform.component";
import {SalesPhoneKnoxKrdyaPlatformComponent} from "./platforms/knox-krdya/sales-phone-knox-krdya-platform.component";
import {SalesPhoneNuovoKrdyaPlatformComponent} from "./platforms/nuovo-krdya/sales-phone-nuovo-krdya-platform.component";
import {SalesPhoneTrustonicPlatformComponent} from "./platforms/trustonic/sales-phone-trustonic-platform.component";
import {SalesPhoneTrustonicPrepaidPlatformComponent} from "./platforms/trustonic-prepaid/sales-phone-trustonic-prepaid-platform.component";
import {SalesPhoneDatacultrPlatformComponent} from "./platforms/datacultr/sales-phone-datacultr-platform.component";
import {SalesPhoneKnoxPlatformComponent} from "./platforms/knox/sales-phone-knox-platform.component";
import {SalesPhoneNuovoPlatformComponent} from "./platforms/nuovo/sales-phone-nuovo-platform.component";
import {SalesPhoneAbsolutePlatformComponent} from "./platforms/absolute/sales-phone-absolute-platform.component";
import {LibraryModule} from "library";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {GeneralModule} from "../general/general.module";
import {QRCodeModule} from "angularx-qrcode";



@NgModule({
  declarations: [
    SalesPhoneAppInstalationComponent,
    SalesCreditCodesSharedComponent,
    PhoneAppConfirmationModalSharedComponent,
    PhoneAppFooterButtonSharedComponent,
    SalesPhoneKrdyaPlatformComponent,
    SalesPhoneKnoxKrdyaPlatformComponent,
    SalesPhoneNuovoKrdyaPlatformComponent,
    SalesPhoneTrustonicPlatformComponent,
    SalesPhoneTrustonicPrepaidPlatformComponent,
    SalesPhoneDatacultrPlatformComponent,
    SalesPhoneKnoxPlatformComponent,
    SalesPhoneNuovoPlatformComponent,
    SalesPhoneAbsolutePlatformComponent,
  ],
  imports: [
    CommonModule,
    LibraryModule,
    PrimengModule,
    GeneralModule,
    QRCodeModule,
  ],
  exports: [
    SalesPhoneAppInstalationComponent,
  ]
})
export class SalesPhoneAppInstalationModule { }